import { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { useAlert } from 'react-alert';
import { useNavigate } from "react-router-dom";
import { reportPaymentError } from "../analytics";

export default function CheckoutComponent({clientSecret, onSuccess} : {clientSecret: string, onSuccess?: () => void}) {
    const alert = useAlert();
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        if (!stripe) {
            return;
        }
    
        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent?.status) {
            case "succeeded":
                alert.success("Platba připravena")
            break;
            case "processing":
                alert.info("Platba se zpracovává")
            break;
            case "requires_payment_method":
            break;
            default:
                reportPaymentError("intent_status_unexpected", paymentIntent?.status);
                alert.error("Něco se pokazilo")
            break;
        }
        });
    }, [stripe]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        alert.info("Platba se zpracovává")
    
        if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
        }
    
        setIsLoading(true);
    
        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            redirect: "if_required",
            confirmParams: {
                // Where Stripe returns the buyer for redirect-based methods / 3DS. Must be
                // the real deployed origin — a hardcoded localhost stranded production buyers.
                return_url: window.location.origin + "/kurz"
        }});

        if (paymentIntent?.status === "succeeded") {
            alert.success("Platba proběhla úspěšně")
            if (onSuccess) {
                onSuccess();
            } else {
                navigate("/kurz")
            }
            return;
        }

        // Payment didn't complete — capture why. Card declines, 3DS failures and network
        // errors here otherwise leave no trace on the client or the server.
        reportPaymentError("confirm_failed", error?.code || error?.type || paymentIntent?.status);

        if (error?.type === "card_error") {
            setMessage(error.message!);
        }

        alert.error("Nastala chyba")

        setIsLoading(false);
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />

            <button className={"pay" + ((isLoading || !stripe || !elements) ? " disabled" : "")} id="submit">
                Zaplatit
            </button>

            {message && <div id="payment-message">{message}</div>}
        </form>
    );
}

